export class TriggerConfigURLs {
  urlvalue: string;
  urlkey: string; 
}
